import useScrollTriggerContext from '@contexts/scrollTriggerContext'
import theme, { size } from '@styles/theme'
import styled from '@emotion/styled'
import GearIconButton from '@elements/GearIconButton'
import AppBarAvatar from '@elements/AppBarAvatar'
// import NavTextField from '@elements/NavTextField'
import HideOnScroll from '@elements/HideOnScroll'
import { Toolbar, Tabs } from '@mui/material'
import NavHeading from '@elements/NavHeading'
import BaseAppBar from '@elements/BaseAppBar'
import { PiGear } from 'react-icons/pi'
import StyledTab from '@elements/Tab'

const HomeToolbar = styled(Toolbar)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AppBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 100;
  width: 100%;
  
  border-bottom: 0.5px solid rgba(255,255,255, 0.2);
  // background-color: rgba(0,0,0,1);
  ${theme.glassBackgruond(0.9)}
`

const ConversationsTopNav = ({ selectedItem, setSelectedItem }) => {
  const { scrollTrigger } = useScrollTriggerContext()

  return (
    <AppBarContainer className={scrollTrigger ? 'animation__hide-top-nav' : 'animation__show-top-nav'}>
      <BaseAppBar>
        <HomeToolbar>
          <AppBarAvatar />
          <NavHeading>Messages</NavHeading>
          {/* TODO: we'll add this feature eventually, but not at launch */}
          {/* <NavTextField placeholder='Search Messages' /> */}
          <GearIconButton style={{ visibility: 'hidden' }} />
        </HomeToolbar>
      </BaseAppBar>
      <Tabs
        slotProps={{ list: { sx: { display: 'flex', justifyContent: 'center', gap: size(5), width: '100%' } } }}
        centered
        onChange={(_, val) => setSelectedItem(val)}
        aria-label="home view tabs"
        value={selectedItem}>
        <StyledTab label='All' color={selectedItem === 0 ? 'white' : 'grey'} />
        <StyledTab label='Favorites' color={selectedItem === 1 ? 'white' : 'grey'} />
      </Tabs>
    </AppBarContainer>
  )
}

export default ConversationsTopNav
